var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubjectTracks = function SvgSubjectTracks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "subjectTracks_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 62 62"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subjectTracks_svg__cls-2{fill:#333}"))), /*#__PURE__*/React.createElement("g", {
    id: "subjectTracks_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subjectTracks_svg__subject-tracks"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "subjectTracks_svg__subject-tracks_box",
    width: 56,
    height: 56,
    x: 3,
    y: 3,
    rx: 8,
    ry: 8,
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subjectTracks_svg__subject-tracks_path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1",
    d: "M37.52 18c-.47 0-.87-.34-.99-.84-.07-.29-.03-.57.11-.82s.36-.44.62-.51l2.97-.8c.53-.14 1.1.22 1.23.8.02.09.03.19.03.27 0 .51-.32.93-.77 1.06l-2.96.8q-.12.03-.24.03Z",
    className: "subjectTracks_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-2",
    d: "M29.52 20c-.47 0-.87-.34-.99-.84-.07-.29-.03-.57.11-.82s.36-.44.62-.51l2.97-.8c.53-.14 1.1.22 1.23.8.02.09.03.19.03.27 0 .51-.32.93-.77 1.06l-2.96.8q-.12.03-.24.03Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-3",
    d: "M21.52 22c-.47 0-.87-.34-.99-.84-.07-.29-.03-.57.11-.82s.36-.44.62-.51l2.97-.8c.53-.14 1.1.22 1.23.8.02.09.03.19.03.27 0 .51-.32.93-.77 1.06l-2.96.8q-.12.03-.24.03Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-4",
    d: "M28.52 45c-.47 0-.87-.34-.99-.84-.07-.29-.03-.57.11-.82s.36-.44.62-.51l2.97-.8c.53-.14 1.1.22 1.23.8.02.09.03.19.03.27 0 .51-.32.93-.77 1.06l-2.96.8q-.12.03-.24.03Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-5",
    d: "M21.52 47c-.47 0-.87-.34-.99-.84-.07-.29-.03-.57.11-.82s.36-.44.62-.51l2.97-.8c.53-.14 1.1.22 1.23.8.02.09.03.19.03.27 0 .51-.32.93-.77 1.06l-2.96.8q-.12.03-.24.03Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-6",
    d: "M21.89 26.06c.21.38.1.86-.26 1.17a1.1 1.1 0 0 1-.73.27c-.27 0-.52-.1-.69-.29l-1.98-2.08c-.35-.37-.3-1 .12-1.36.06-.05.14-.11.21-.14.42-.22.92-.14 1.22.17l1.97 2.08c.05.06.1.12.13.19Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-7",
    d: "M27.89 32.06c.21.38.1.86-.26 1.17a1.1 1.1 0 0 1-.73.27c-.27 0-.52-.1-.69-.29l-1.98-2.08c-.35-.37-.3-1 .12-1.36.06-.05.14-.11.21-.14.42-.22.92-.14 1.22.17l1.97 2.08c.05.06.1.12.13.19Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "subjectTracks_svg__path-1-8",
    d: "M32.89 38.06c.21.38.1.86-.26 1.17a1.1 1.1 0 0 1-.73.27c-.27 0-.52-.1-.69-.29l-1.98-2.08c-.35-.37-.3-1 .12-1.36.06-.05.14-.11.21-.14.42-.22.92-.14 1.22.17l1.97 2.08c.05.06.1.12.13.19Z",
    className: "subjectTracks_svg__cls-2",
    "data-name": "path-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "subjectTracks_svg__subject-tracks_point"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "subjectTracks_svg__subject-tracks_point-bl",
    cx: 15,
    cy: 47.5,
    r: 4,
    className: "subjectTracks_svg__cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "subjectTracks_svg__subject-tracks_point-tr",
    cx: 47,
    cy: 14.5,
    r: 4,
    className: "subjectTracks_svg__cls-2"
  }))))));
};
export default SvgSubjectTracks;